/**
 * @generated SignedSource<<3e261db26d1d024b6da239237bbfbcea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type body_versionIssueAssociatedDesigns_IssuesModalBody$data = {
  readonly associatedIssues: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly hasRelationshipToVersion?: boolean | null | undefined;
        readonly key?: string;
        readonly " $fragmentSpreads": FragmentRefs<"simpleIssueCard_versionIssueAssociatedDesigns">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "body_versionIssueAssociatedDesigns_IssuesModalBody";
};
export type body_versionIssueAssociatedDesigns_IssuesModalBody$key = {
  readonly " $data"?: body_versionIssueAssociatedDesigns_IssuesModalBody$data;
  readonly " $fragmentSpreads": FragmentRefs<"body_versionIssueAssociatedDesigns_IssuesModalBody">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "versionId"
    }
  ],
  "kind": "Fragment",
  "name": "body_versionIssueAssociatedDesigns_IssuesModalBody",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
      "kind": "LinkedField",
      "name": "associatedIssues",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      "action": "THROW",
                      "path": "associatedIssues.edges.node.key"
                    },
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "versionId",
                          "variableName": "versionId"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "hasRelationshipToVersion"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                    }
                  ],
                  "type": "JiraIssue"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "associatedIssues(first:100)"
    }
  ],
  "type": "DevOpsDesign"
};

(node as any).hash = "145e33a9a0a82742e3ace6aa6c154644";

export default node;
